export default __webpack_public_path__ + "static/media/ico-MinusSquare.e3760dde.svg";